import _ from "lodash";
import React, { useEffect, useState, useContext } from "react";
// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import { exportToExcel } from "utils/AppUtils";
import CreateTableBtn from "components/Buttons/CreateTableBtn";
import StoreContext from "contexts/StoreContext";
import HippoTable from "components/ReactTable/HipposReactTable";
import StatusColumn from "components/Custom/StatusColumn";
import ColorColumn from "components/Custom/ColorColumn";
import TimestampColumn from "components/Custom/TimestampColumn";
import EditButton from "views/Components/EditButton";
import ExportToExcelButton from "views/Components/ExportToExcelButton";
import ImportCsvButton from "views/Components/ImportCsvButton";
import ImportCsvModal from "components/Modals/ImportCsvModal";
import moment from "moment";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function ExtraListPage() {
  const {
    t,
  } = useTranslation();

  const [data, setData] = useState([]);
  const { storeId, setStoreId } = useContext(StoreContext);
  const [alert, setAlert] = useState(null);
  const [excelLoading, setExcelLoading] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [showImport, setShowImport] = useState(false);

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      maxWidth: 70,
      minWidth: 40,
      width: 60,
    },
    {
      Header: t("tables.headers.description"),
      accessor: "name",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.price"),
      accessor: "price",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.extraCategory"),
      accessor: "extraCategory",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.position"),
      accessor: "order",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.status"),
      accessor: "status",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.color"),
      accessor: "colorComponent",
      minWidth: 100,
      maxWidth: 200,
      width: 100,
    },
    {
      Header: t("tables.headers.actions"),
      accessor: "edit",
      minWidth: 200,
      maxWidth: 200,
      width: 200,
    },
  ];

  const fetchData = async () => {
    try {
      setShowLoader(true);
      const dataResponse = await apiService.get(`api/v1/extras/store/${storeId}`);
      setData(attachCustom(dataResponse));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
    const enhanced = data.map((el) => {
      el.status = <StatusColumn value={el.deleted} />;
      el.colorComponent = <ColorColumn color={el.color} />;
      el.timestamp = <TimestampColumn timestamp={el.updatedAt} />;
      el.edit = <EditButton uri={`/admin/extra/${el.id}`} />;
      el.price = el.price.toFixed(2);
      el.extraCategory = el.extraCategory.name;
      return el;
    });
    return _.sortBy(enhanced, ["order", "id"]);
  };

  const formatData = (data) => {
    const formattedData = data.map((extra) => {
      return {
        ID: extra.id,
        [t("tables.headers.description")]: extra.name,
        [t("tables.headers.price")]: extra.price.toFixed(2),
        [t("tables.headers.extraCategory")]: extra.extraCategory.name,
        [t("tables.headers.position")]: extra.order,
        [t("tables.headers.updatedAt")]: moment(extra.updatedAt).format("DD/MM/YYYY HH:mm:ss"),
        [t("tables.headers.color")]: extra.color,
        [t("tables.headers.deleted")]: extra.deleted ? "NAI" : "OXI",
        [t("tables.headers.deletedAt")]: extra.deletedAt ? moment(extra.deletedAt).format("DD/MM/YYYY HH:mm:ss") : null,
      };
    });
    return formattedData;
  };

  const handleExportData = async () => {
    try {
      setExcelLoading(true);
      const dataResponse = await apiService.get(`api/v1/extras/store/${storeId}`);
      exportToExcel(formatData(dataResponse), `extras_${moment().format("YYYYMMDD")}`, t("messages.storeProductExtras"));
      setExcelLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
      setExcelLoading(false);
    }
  };

  useEffect(() => {
    if (!storeId) return;
    fetchData();
  }, [storeId]);

  return (
    <>
      {alert}
      <ImportCsvModal type="extras" title={t("pages.titles.importExtras")} show={showImport} handleClose={() => setShowImport(false)} onImported={fetchData} />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Body>
                <Row className="mx-1">
                  <CreateTableBtn route={"/admin/extra"} />
                  <ExportToExcelButton handler={handleExportData} disabled={excelLoading} />
                  <ImportCsvButton handler={() => setShowImport(true)} />
                </Row>
                <Row>
                  <Col>
                    {showLoader ? (
                      <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                        <ClipLoader size={50} color={"#ff6fbc"} />
                      </div>
                    ) : (
                      <HippoTable data={data} columns={columns} className="-striped -highlight primary-pagination" />
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ExtraListPage;
